import { render, staticRenderFns } from "./ProductsReportTableTransit.vue?vue&type=template&id=4f3c5f41&scoped=true"
import script from "./ProductsReportTableTransit.vue?vue&type=script&lang=js"
export * from "./ProductsReportTableTransit.vue?vue&type=script&lang=js"
import style0 from "./ProductsReportTableTransit.vue?vue&type=style&index=0&id=4f3c5f41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3c5f41",
  null
  
)

export default component.exports